import { DataTable } from 'primereact/datatable'
import React, { useEffect, useState } from 'react'
import {  ISalesAllocation } from '../salesAllocation/Table';
import { Column } from 'primereact/column';
import { Fetch } from '../../shared/Fetch';
import { Dialog } from 'primereact/dialog';


interface IProps {
    singleData: ISalesAllocation,
    open: boolean,
    hideDialog: () => void,
    toast: any
   
}

export const TableHistory = (props:IProps) => {
  
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ISalesAllocation>, loading: boolean });
   


    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
         const response = await Fetch("NonPerformingPVAllocation", "GET", null, `Vendor_Company_ID=${props.singleData.vendor_Company_ID}&Company_ID=${props.singleData.company_ID}`, props.toast);
          if (response) {
            const data: Array<ISalesAllocation> = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
        console.log(tableData );
    };
    useEffect(() => {
        if (props.open && props.singleData.vendor_Company_ID && props.singleData.company_ID) loadTableData();
    }, [props.open])
    

    // const header = (
    //     <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
    //         <h5 className="m-0"></h5>
    //         {/* <span className="block mt-2 md:mt-0 p-input-icon-left">
    //             <Button icon="pi pi-filter" onClick={() => setFilter(true)} className="p-button-rounded p-button-secondary ml-2" aria-label="Filter" />
    //         </span> */}
    //     </div>
    // );

    const onHide = () => {
        props.hideDialog();
        setTableData({ tableData: [], loading: false });
    }

    const converted_Type = (rowData: ISalesAllocation) => {
        return (
            <span className="" >{rowData.converted ? "Yes" : "No"}</span>
        );
    };
  return (
    <>
    <Dialog visible={props.open} style={{ width: '80vw' }} header="Allocation History "  className="p-fluid" onHide={onHide}>
     <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                value={tableData.tableData}
                loading={tableData.loading}
                showGridlines
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1}/>
                <Column field="vendor_Company_Name" header="Vendor Company Name" />
                <Column field="sales_Manager" header="Sales Manager" />
                <Column field="company" header="Company" />
                <Column field="branch" header="Branch" />
                <Column field="converted" header="Converted" body={converted_Type} />
                <Column field="createdOn" header="Date" body={(rowData)=><p>{rowData.createdOn.split("T")[0].split("-")[2]}/{rowData.createdOn.split("T")[0].split("-")[1]}/{rowData.createdOn.split("T")[0].split("-")[0]}</p>} />
            </DataTable>
            </Dialog>
    </>
  )
}
